import { createSelector, createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../api/apiSlice";

const titularidadContratosAdapter = createEntityAdapter({
  // Assume IDs are stored in a field other than `book.id`
  selectId: (x) => x.contratoId + "-" + x.personaId,

  // Keep the "all IDs" array sorted based on book titles
  // sortComparer: (a, b) => a.title.localeCompare(b.title),
})

const initialState = titularidadContratosAdapter.getInitialState();

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getTitularidadContratos: builder.query({
      query: () => 'titularidadcontratos',
      transformResponse: responseData => {
        return titularidadContratosAdapter.setAll(initialState, responseData)
      },
      providesTags: (result, error, arg) => [
        { type: 'TitularidadContratos', id: 'LIST' }
      ]
    }),
    getTitularidadContratosCdc: builder.query({
      query: ()=> 'titularidadcontratos-cdc',
      providesTags: (result, error, arg)=>[
        {type:'CDC_TitularidadContratos', id: 'LIST'}
      ]
    }),
  })
});

export const { useGetTitularidadContratosQuery, useGetTitularidadContratosCdcQuery } = extendedApiSlice;

//A: returns the query result object
export const selectTitularidadContratosResut = extendedApiSlice.endpoints.getTitularidadContratos.select();

//A: created memoized selector
const selectTitularidadContratosData = createSelector(
  selectTitularidadContratosResut,
  titularidadContratosResult => titularidadContratosResult.data  //A: normalized state object with ids and entities
);


//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
  selectAll: selectAllTitularidadContratos,
  selectById: selectTitularidadContratosById,
  selectIds: selectTitularidadContratosIds
} = titularidadContratosAdapter.getSelectors(state => selectTitularidadContratosData(state) ?? initialState);

//A:selector for get all titularidades by userId
const selectPersonaId = (state, personaId) => personaId

export const selectTitularidadByUserId = createSelector(
  [selectAllTitularidadContratos, selectPersonaId],
  (contratos, personaId) =>contratos.filter(contrato => contrato.personaId == personaId) 
)